import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'stf-table-toolbar',
  templateUrl: './table-toolbar.component.html',
  styleUrls: ['./table-toolbar.component.scss'],
})
export class TableToolbarComponent implements OnInit {
  @Input() hasSelected = false;

  constructor() { }

  ngOnInit() {
  }

}
